import React from 'react';
import PropTypes from 'prop-types';
import useAssetMediaPublic from '../hooks/useAssetMediaPublic';
import formatBytes from '../../shared/utils/formatBytes';

function DocumentCard({ item, onOpen }) {
  return (
    <button
      type="button"
      className="card file-list-card mb-2 shadow-sm border-0 bg-white text-start p-0"
      style={{ cursor: 'pointer' }}
      onClick={() => onOpen(item.id)}
    >
      <div className="card-body file-list-row">
        <i className="bi bi-file-earmark text-secondary" aria-hidden />
        <div className="min-w-0">
          <div className="fw-semibold file-list-row__name" title={item.filename}>
            {item.filename}
          </div>
          {item.byte_size != null && (
            <span className="small text-muted">{formatBytes(item.byte_size)}</span>
          )}
        </div>
        <i className="bi bi-box-arrow-up-right text-secondary" aria-hidden />
      </div>
    </button>
  );
}

DocumentCard.propTypes = {
  item: PropTypes.object.isRequired,
  onOpen: PropTypes.func.isRequired,
};

export default function AssetDocumentsPanel({ accessKey, fieldEngineerId }) {
  const { items, loading, error, openError, openDocument } = useAssetMediaPublic(accessKey, fieldEngineerId);

  if (loading) {
    return (
      <div className="mb-4 min-w-0">
        <h5>Documents</h5>
        <div className="text-muted small">
          <span className="spinner-border spinner-border-sm me-2" role="status" />
          Loading documents…
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mb-4 min-w-0">
        <h5>Documents</h5>
        <div className="alert alert-warning py-2 small mb-0">{error}</div>
      </div>
    );
  }

  if (items.length === 0) {
    return null;
  }

  const assetItems = items.filter((item) => item.scope !== 'organization');
  const organizationItems = items.filter((item) => item.scope === 'organization');

  return (
    <div className="mb-4 min-w-0">
      <h5>Documents</h5>
      {openError && (
        <div className="alert alert-warning py-2 small mb-2">{openError}</div>
      )}
      {assetItems.map((item) => (
        <DocumentCard key={item.id} item={item} onOpen={openDocument} />
      ))}
      {organizationItems.length > 0 && (
        <>
          <h6 className="text-muted small text-uppercase fw-semibold mt-3 mb-2">
            Organization documents
          </h6>
          {organizationItems.map((item) => (
            <DocumentCard key={item.id} item={item} onOpen={openDocument} />
          ))}
        </>
      )}
    </div>
  );
}

AssetDocumentsPanel.propTypes = {
  accessKey: PropTypes.string.isRequired,
  fieldEngineerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
